import stockAPI from "@/utility/api.js";
import { termInChinese } from "@/utility/termInChinese.js";
export const reportRatioQuarter = {
  state: {
    reportRatioQuarter: [
      {
        company_name: "",
        stock_symbol: null,
        quarter_liquidities: [
          {
            accounts_and_bills_payable: "",
            accounts_and_bills_receivable: "",
            bank_loan_non_current: "",
            cash_and_cash_equivalents: "",
            commercial_paper_payable_acceptance_bill: "",
            corporate_bond: "",
            current_assets: "",
            current_liabilities: "",
            current_tax_liabilities: "",
            financial_liabilities_non_current: "",
            inventories: "",
            loan_to_other_S_T: "",
            long_term_investments: "",
            long_term_liabilities_due_within_one_year: "",
            non_current_assets: "",
            non_current_liabilities: "",
            other_current_assets: "",
            other_current_liabilities: "",
            other_financial_liabilities_current: "",
            other_long_term_debt_payable_non_current: "",
            other_non_current_assets: "",
            other_payables: "",
            other_receivables: "",
            prepaid_expenses_and_repayments: "",
            property_plant_and_equipment: "",
            short_term_debt: "",
            short_term_financial_liability_current: "",
            short_term_investment_financial_assets_current: "",
            total_assets: "",
            total_goodwill_and_intangible_assets: "",
            total_intangible_assets: "",
            total_liabilities: "",
            total_other_L_T_liab: "",
            quarter: ""
          }
        ],
        quarter_return_on_investments: [
          {
            EBOA: "",
            EBOE: "",
            EBOIC: "",
            ROA: "",
            ROE: "",
            ROIC: "",
            gross_profit_ratio: "",
            net_profit_margin_ratio: "",
            operating_expense_ratio: "",
            quarter: ""
          }
        ],
        quarter_per_share_ratios: [
          {
            EBIDTA_per_share: "",
            cash_reinvestment_ratio: "",
            dividend_redistribution_ratio: "",
            quarter: "",
            EPS_of_recently_four_seasons: "",
            EPS: ""
          }
        ],
        quarter_operating_performances: [
          {
            days_of_accounts_payable_turnover: "",
            days_of_cash_receivable: "",
            days_of_cash_turnover: "",
            days_of_operation_turnover: "",
            days_of_sales: "",
            quarter: ""
          }
        ]
      }
    ],
    errorMessageWithReportRatioQuarter: null
  },
  getters: {
    reportRatioQuarter: state => state.reportRatioQuarter,
    errorMessageWithReportRatioQuarter: state =>
      state.errorMessageWithReportRatioQuarter,
    liquiditiesQuarter: ({ reportRatioQuarter: [{ quarter_liquidities }] }) =>
      quarter_liquidities,
    returnOnInvestmentsQuarter: ({
      reportRatioQuarter: [{ quarter_return_on_investments }]
    }) => quarter_return_on_investments,
    perShareRatiosQuarter: ({
      reportRatioQuarter: [{ quarter_per_share_ratios }]
    }) => quarter_per_share_ratios,
    operatingPerformancesQuarter: ({
      reportRatioQuarter: [{ quarter_operating_performances }]
    }) => quarter_operating_performances,
    fieldsOfLiquiditiesQuarter: (state, getters) =>
      getters.fieldsOfQuarter(getters.liquiditiesQuarter),
    fieldsOfReturnOnInvestmentsQuarter: (state, getters) =>
      getters.fieldsOfQuarter(getters.returnOnInvestmentsQuarter),
    fieldsOfPerShareRatiosQuarter: (state, getters) =>
      getters.fieldsOfQuarter(getters.perShareRatiosQuarter),
    fieldsOfOperatingPerformancesQuarter: (state, getters) =>
      getters.fieldsOfQuarter(getters.operatingPerformancesQuarter),
    itemsOfLiquiditiesQuarter: (state, getters) =>
      getters.formatOfReportRatioQuarter(getters.liquiditiesQuarter),
    layerOfLiquiditiesQuarter: (state, getters) =>
      getters.layerOfTableArea(getters.itemsOfLiquiditiesQuarter),
    itemsOfReturnOnInvestmentsQuarter: (state, getters) =>
      getters.formatOfReportRatioQuarter(getters.returnOnInvestmentsQuarter),
    itemsOfPerShareRatiosQuarter: (state, getters) =>
      getters.formatOfReportRatioQuarter(getters.perShareRatiosQuarter),
    itemsOfOperatingPerformancesQuarter: (state, getters) =>
      getters.formatOfReportRatioQuarter(
        getters.operatingPerformancesQuarter,
        "days"
      ),
    // 全區英翻中小標題與對應值百分比、元與天數格式化。
    formatOfReportRatioQuarter: (state, getters) => (dataSets, status) => {
      const fields = Object.keys(dataSets.slice().shift()).filter(
        field => field !== "quarter"
      );
      const data = fields.map(field => {
        return dataSets.reduce((res, current) => {
          res = { ...res };
          res.subTitle = termInChinese.get(field);

          if (
            status === "days" ||
            field === "EBIDTA_per_share" ||
            field === "EPS_of_recently_four_seasons" ||
            field === "EPS"
          ) {
            // days 單位是天、EBIDTA_per_share、EPS_of_recently_four_seasons、EPS 單位是元，不用換成百分比
            res[current.quarter] = current[field];
          } else if (current[field] === null) {
            // 當值是 null 要轉成 NA
            res[current.quarter] = "NA";
          } else {
            res[current.quarter] = getters.number2Percentage(current, field);
          }

          return res;
        }, {});
      });
      return data;
    }
  },
  mutations: {
    reportRatioQuarter(state, res) {
      state.reportRatioQuarter = res;
    },
    errorMessageWithReportRatioQuarter(state, res) {
      state.errorMessageWithReportRatioQuarter = res || "";
    }
  },
  actions: {
    async FETCH_REPORT_RATIO_QUARTER({ commit, rootState }) {
      try {
        const res = await stockAPI.GET(
          `/api/report/ratio/quarter/${rootState.stockSymbol}`
        );
        commit("reportRatioQuarter", res);
        // 共用 rootState 儲存股票代號。
        commit("storageCompanyName", res, { root: true });
        commit("errorMessageWithReportRatioQuarter", null);
      } catch ({ message }) {
        commit("errorMessageWithReportRatioQuarter", message);
        console.error(message);
      }
    }
  }
};
